import { t } from 'i18next';
import * as yup from 'yup';

/** Phone Number is built in and does not count against this. Mirrors ClientManager.MAX_SITE_CUSTOM_PERSON_FIELDS on
 * the API, which rejects anything over it. */
export const MAX_SITE_CUSTOM_PERSON_FIELDS = 5;

export const PHONE_NUMBER_PERSON_FIELD_TYPE = 'PhoneNumber';
export const CUSTOM_PERSON_FIELD_TYPE = 'Custom';

export const siteSchema = yup.object().shape({
  pathSegment: yup
    .string()
    .required(t('site.general.sitePathRequired'))
    .matches(/^[a-zA-Z0-9-_]+$/, t('site.general.sitePathInvalid')),
  authenticationConnectionId: yup.string().optional(),
  wicketAuthEnabled: yup.boolean().optional(),
  requirePersonNames: yup.boolean().optional(),
  personFields: yup
    .array()
    .of(
      yup.object({
        type: yup.string().oneOf([PHONE_NUMBER_PERSON_FIELD_TYPE, CUSTOM_PERSON_FIELD_TYPE]).required(),
        key: yup.string().optional(),
        required: yup.boolean().required(),
      }),
    )
    .optional()
    .test(
      'maxCustomPersonFields',
      t('site.personFields.maxFieldsError', { max: MAX_SITE_CUSTOM_PERSON_FIELDS }),
      (personFields) =>
        (personFields ?? []).filter((field) => field?.type === CUSTOM_PERSON_FIELD_TYPE).length <=
        MAX_SITE_CUSTOM_PERSON_FIELDS,
    ),
  design: yup
    .object({
      introduction: yup
        .object({
          enabled: yup.boolean().optional(),
          html: yup.string().optional(),
        })
        .optional(),
      campaignPageTitle: yup.string().optional(),
      campaignPageDescriptionHtml: yup.string().optional(),
      largeLogoImageId: yup.string().nullable().optional(),
      largeLogoImageUrl: yup.string().optional(),
      smallLogoImageId: yup.string().nullable().optional(),
      smallLogoImageUrl: yup.string().optional(),
      backgroundImageId: yup.string().nullable().optional(),
      backgroundImageUrl: yup.string().optional(),
      useWicketFooter: yup.boolean().optional(),
      footerHtml: yup.string().optional(),
      privacyPolicyHtml: yup.string().optional(),
      privacyPolicyAgreementText: yup.string().optional(),
      styleSheet: yup.string().optional(),
    })
    .optional(),
});

export type SiteFormValues = yup.InferType<typeof siteSchema>;
